import React, { useMemo } from 'react'
import { If } from '@sui/sui'

const AccessState = React.createContext({})

/**
 * 权限组件
 * @returns 
 */
export function Access(props) {
  const { children, accessible, fallback } = props
  return (
    <If condition={!!accessible} fallback={fallback}>{children}</If>
  )
}

/**
 * access provider
 * @param {*} props 
 * @returns 
 */
export function AccessProvider(props){
  const { children, access } = props;
  const value = useMemo(()=>({
    access
  }), [ access ])
  return <AccessState.Provider value={value}>
    {children}
  </AccessState.Provider>
}

/**
 * 获取access权限
 * @returns 
 */
export function useAccess(){
    const { access = {} } = React.useContext(AccessState)
    return access
}

/**
 * 获取access权限状态
 * @returns 
 */
export function useAccessState(){
  return React.useContext(AccessState)
}

/**
 * @name 设置权限路由依赖
 */
function parentRouteAccessDepsNum(parentRoute, hasAccess){
  parentRoute.__accessDepsNum__ = parentRoute.__accessDepsNum__ || 0;
  if ( hasAccess ) {
    parentRoute.__accessDepsNum__++;
  }
  if ( parentRoute.__parentRoute__ ) {
    parentRouteAccessDepsNum(parentRoute.__parentRoute__, hasAccess)
  }
}

/**
 * 修改并设置路由权限
 * @param {*} routes 
 * @param {*} access 
 * @param {*} parentUnaccessible
 */
/**
 * 修改并设置路由权限
 * @param {*} routes 
 * @param {*} access 
 * @param {*} strictMode
 * @param {*} parentUnaccessible
 */
 export function modifyRoutesByAccess(routes, access, strictMode,  parentUnaccessible, parentRoute){
  
  return [].concat(routes).map(route => {
      // 默认情况下，初始权限为已定义或继承上级权限
      let accessible = typeof route.unaccessible === 'boolean' ? !route.unaccessible : parentUnaccessible !== true;
      if ( strictMode ) { // 严格模式下，默认不通过
        accessible = false;
      }
      if ( route.access ) { // 当设置了权限，默认不通过，只有权限通过才能访问
          accessible = false;
          const accesses = [].concat(route.access)
          for (let index = 0; index < accesses.length; index++) {
              const accessName = accesses[index];
              if (access && access[accessName]) {
                  accessible = typeof access[accessName] === 'function' ? access[accessName](route) == true : true
                  break;
              }
          }
      }
      route.unaccessible = !accessible;

      if ( !route.unaccessible && parentRoute && !strictMode ) { // 非严格模式下的，处理权限 path 依赖链，以保证在子层的路由可访问到
        parentRouteAccessDepsNum(parentRoute, true)
      }
      if ( route.children && route.children.length ) {
        route.children = modifyRoutesByAccess(route.children, access, strictMode, route.unaccessible, route)
      }
      return route
  });
}

/**
 * 获取菜单paths
 * @param {*} menus 
 * @param {*} paths 
 */
export function getAccessMenusPaths(menus, paths){
  paths = paths || []
  if ( !menus || !menus.length ) {
    return paths
  }
  menus.forEach(menu=>{
    menu.path && paths.push(menu.path)
    if ( menu.children ) {
      getAccessMenusPaths(menu.children, paths)
    }
  })
  return paths
}

/**
 * 根据权限菜单处理路由权限
 * @param {*} routes 
 * @param {*} accessPaths 
 * @param {*} strictMode 
 * @param {*} parentUnaccessible 
 */
export function modifyRoutesByAccessMenus(routes, accessPaths, strictMode, parentUnaccessible){
  if ( accessPaths && accessPaths.length && routes && routes.length ) {
      routes.forEach(route=>{
          // 默认情况下，初始权限为已定义或继承上级权限
          let accessible = typeof route.unaccessible === 'boolean' ? !route.unaccessible : parentUnaccessible !== true;
          if ( strictMode ) { // 严格模式下，默认不通过
            accessible = false;
          }
          if ( accessPaths.indexOf( route.absolutePath ) > -1 ) {
            accessible = true;
          }
          route.unaccessible = !accessible;
          if ( route.children && route.children.length ) {
            modifyRoutesByAccessMenus(route.children, accessPaths, strictMode, route.unaccessible)
          }
      })
  }
}